import { useEffect, useRef } from 'react';
import { RenderIf, MarkdownOutput } from 'react-rainbow-components';
import { Container, FilesListContainer, StyledMarkdownOutput } from './styled';
import NoteAttachedFile from './file';

interface CustomerNoteProps {
    text?: string;
    attachedFiles?: string[];
}

const CustomerNote = ({ text, attachedFiles = [] }: CustomerNoteProps) => {
    const markdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (markdownRef.current) {
            const links = markdownRef.current.querySelectorAll('a');
            links.forEach((link) => {
                link.setAttribute('target', '_blank');
                link.setAttribute('rel', 'noopener noreferrer');
            });
        }
    }, [text]);

    return (
        <Container>
            <StyledMarkdownOutput ref={markdownRef}>
                <MarkdownOutput value={text || ''} />
            </StyledMarkdownOutput>
            <RenderIf isTrue={attachedFiles.length > 0}>
                <FilesListContainer>
                    {attachedFiles.map((fileId) => (
                        <NoteAttachedFile key={fileId} fileId={fileId} />
                    ))}
                </FilesListContainer>
            </RenderIf>
        </Container>
    );
};

export default CustomerNote;
